module.exports = __webpack_public_path__ + "8e76135d14c9b600160862391e04fc48.svg";